import { Fragment, ReactElement } from 'react';
import ResearchCitizenshipAnscNotificationsShared from 'shell/components/shared/ansc-notifications/research-citizenship';
import { CitizenshipAnscNotificationsSubscriptionCrumbs } from 'subscription/constants/ansc-notifications.crumbs';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchCitizenshipAnscNotificationsPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchCitizenshipAnscNotificationsShared
        scope={IdAmbito.Iscrizioni}
        items={CitizenshipAnscNotificationsSubscriptionCrumbs()}
      />
    </Fragment>
  );
};

ResearchCitizenshipAnscNotificationsPage.displayName =
  'Research Citizenship Notifications Page component';

export default ResearchCitizenshipAnscNotificationsPage;
